<template>
  <v-autocomplete
    outlined
    hide-details
    clearable
    return-object
    no-filter
    hide-selected
    hide-no-data
    item-text="descricao"
    label="Categoria"
    v-model="localValue"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    @blur="onBlur"
    v-bind="$attrs"
  />
</template>

<script>
import { debounce } from 'vuetify/lib/util/helpers';
import CategoriaService from '@/modules/marketplace/categoria/categoria-service';

const DEFAULT_LIMIT = 30;
const DEFAULT_OFFSET = 0;

export default {
  props: {
    value: Object,
  },
  data() {
    return {
      loading: false,
      items: [],
      model: null,
      search: null,
      debounceSearch: null,
    };
  },
  computed: {
    localValue: {
      get() { return this.value; },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  watch: {
    search(val) {
      this.debounceSearch(val);
    },
  },
  methods: {
    searchGrupo(val) {
      if (!val) {
        return;
      }

      if (this.localValue && this.localValue.descricao === val) {
        return;
      }

      this.loading = true;
      CategoriaService.list({
        limit: DEFAULT_LIMIT,
        offset: DEFAULT_OFFSET,
        query: `descricao like "%${val.toLowerCase()}%" order by descricao`,
      })
        .then((response) => {
          this.items = response.data.content;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onBlur(event) {
      this.$emit('blur', event);
    },
  },
  created() {
    this.debounceSearch = debounce(this.searchGrupo, 1000);
    if (this.value) {
      this.items = [this.value];
    }
  },
};
</script>
